import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input
} from "reactstrap"


import moment from "moment"
import IndexBloc from "./Blocs/IndexBlock"
import Select from "react-select"
import DatePicker from '../../../../helpers/ui/DatePicker'

import TableActiveComponent from './Components/TableActiveComponent'

var reformatOptions = function (raw, label, value) {
    return raw.map(function (data) {
        var newObj = {};
        newObj["label"] = data[label];
        newObj["value"] = data[value];

        return newObj;
    });
};

const IndexView = (props) => {
  
    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();

    // Filter
    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'))

    const userdata = JSON.parse(localStorage.getItem('userdata'));

    let additionalFilter = {
        employee_uuid: userdata.employee_uuid,
        start_date: startDate,
        end_date: endDate,
    };

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const exportExcel = () => activeRef.current.exportExcel()

    function handleButtonExport() {
        exportExcel()
    }

    function handleButtonSearch() {
      reloadActiveRef()
    }

    function handleButtonReset() {
        setTimeout(() => {
            reloadActiveRef()
        }, 300);
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">
                        
                        <Card>
                            <CardBody>
                                <div className="float-end">
                                {/* {
                                    (accessRole('create')) ?
                                        <Link to="home.html?create">
                                            <Button color="primary">New Sample</Button>
                                        </Link>
                                    : null
                                } */}
                                </div>
                                <CardTitle>List Data Lembur</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Daftar Lembur Pegawai
                                </CardSubtitle>
                                <hr />

                                <Row className="mb-3">
                                    <label className="col-md-2">
                                        Periode Mulai
                                    </label>
                                    <Col md="3">
                                        <DatePicker 
                                            name="start_date"
                                            isWeekday={false}
                                            dateFormat="dd/MM/yyyy"
                                            placeholder="Tanggal Mulai"
                                            isAvForm={false}
                                            onChange={val => setStartDate(moment(val).format('YYYY-MM-DD'))}
                                            defaultValue={startDate}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <label className="col-md-2">
                                        Periode Akhir
                                    </label>
                                    <Col md="3">
                                        <DatePicker 
                                            name="end_date"
                                            isWeekday={false}
                                            dateFormat="dd/MM/yyyy"
                                            placeholder="Tanggal Selesai"
                                            isAvForm={false}
                                            onChange={val => setEndDate(moment(val).format('YYYY-MM-DD'))}
                                            defaultValue={endDate}
                                        />
                                    </Col>
                                </Row>
                               
                                <Row className="mb-3">
                                    <Col md="2"></Col>
                                    <Col md="10">
                                        <Button 
                                            color="primary" 
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                        {' '}
                                        {/* <Button 
                                          color="warning" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonReset()
                                          }}>
                                            <i className="uil-refresh"></i> Reset
                                        </Button> */}
                                        <Button
                                            color="success"
                                            type="button"
                                            onClick={() => {
                                                handleButtonExport()
                                            }}
                                        >
                                            Export Lembur
                                        </Button>
                                    </Col>
                                </Row>

                                <hr />
                                
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                            </CardBody>
                        </Card>
                        
                       
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView